import { useForm } from 'react-hook-form';

import { ChannelRecordingTaskTypeEnum, ChannelRecordingTaskFormData } from '../types';

export function useRecorderDrawerFormState() {
  const form = useForm<ChannelRecordingTaskFormData>({
    mode: 'all',
    defaultValues: {
      recording_task_type: ChannelRecordingTaskTypeEnum.MANUAL,
      channel_id: '',
      production_center_id: '',
      start_datetime: '',
      end_datetime: '',
      segment_duration: 120,
      file: undefined,
      recording_start_time: '',
      recording_end_time: '',
      file_duration: '',
      description: '',
      parameters: {
        uri: '',
      },
    },
  });

  return { form };
}
